<template>
  <div
    v-clickoutside="close"
    class="search-box flex-item flex-container flex-row flex-horiz-right gjw-transition-300"
    :class="{'search-box-active':active}"
  >
    <div class="auto-complete gjw-transition-300">
      <div
        class="search-input flex-item flex-item-grow flex-container flex-row flex-verti-center gjw-transition-600 "
        :class="{'search-input-focused': inputKeyword }"
      >
        <input
          ref="input"
          :value="inputKeyword"
          :placeholder="placeholder"
          type="text"
          class="flex-item flex-item-grow gjw-transition-300"
          :maxlength="SEARCH_KEYWORD_MAX_LENGTH"
          @input="handleInput"
          @focus="handleFocus"
          @blur="handleBlur"
          @keydown.up.prevent="highlight(highlightedIndex - 1)"
          @keydown.down.prevent="highlight(highlightedIndex + 1)"
          @keydown.enter.prevent="handleEnterEvent"
        >
        <i
          v-if="inputKeyword && showClearBtn"
          class="clear-input-btn gjw-iconfont gjw-icon-clear"
          @click="clearInput"
        />
      </div>
    </div>
    <button
      class="search-button gjw-iconfont gjw-icon-search gjw-transition-300"
      @click="handleSearch"
    />
    <gjw-collapse>
      <ul v-if="active && suggestions.length" class="suggestions-list">
        <li
          v-for="(s,index) in suggestions"
          :key="index"
          class="suggestion line-no-wrap gjw-transition-300"
          :class="{'suggestion-selected':index===highlightedIndex}"
          @click="select(s)"
        >
          {{ s }}
        </li>
      </ul>
    </gjw-collapse>
  </div>
</template>

<script>
import GjwCollapse from '@/components/lib/GjwCollapse'
import eventMixin from '@/mixins/eventMixin'
import { SEARCH_KEYWORD_MAX_LENGTH } from '../constants'
export default {
  name: 'SuggestionSearch',
  components: {
    GjwCollapse
  },
  mixins: [eventMixin],
  props: {
    fetchSuggestions: {
      type: Function,
      default: (data) => {
        return data
      }
    },
    debouceDelay: {
      type: Number,
      default: 50
    },
    // 聚焦即搜索
    immediateSearch: {
      type: Boolean,
      default: true
    },
    keyword: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
    },
    showClearBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      SEARCH_KEYWORD_MAX_LENGTH,
      inputKeyword: this.keyword,
      active: false,
      suggestions: [],
      highlightedIndex: -1,
      imeFlag: false, // 是否处于输入法输入状态
      blurTimer: null
    }
  },
  watch: {
    keyword: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.inputKeyword = newValue
          if (newValue.length > SEARCH_KEYWORD_MAX_LENGTH) {
            this.inputKeyword = newValue.substr(0, SEARCH_KEYWORD_MAX_LENGTH)
          }
        } else {
          this.inputKeyword = newValue
        }
      }
    }
  },
  mounted() {
    this.debounceSetData = this.$debounce(this.getData, this.debouceDelay)
    const input = this.$refs.input
    this.listen(input, 'compositionstart', () => {
      this.imeFlag = true
    })
    this.listen(input, 'compositionend', () => {
      this.imeFlag = false
    })
  },
  methods: {
    handleInput(event) {
      if (!this.active) { this.active = true }
      const e = event || document.event
      this.inputKeyword = e.target.value
      this.debounceSetData(this.inputKeyword)
    },
    handleFocus() {
      this.active = true
      this.blurTimer && clearTimeout(this.blurTimer)
      if (this.immediateSearch && this.inputKeyword) {
        this.getData(this.inputKeyword)
      }
    },
    handleBlur() {
      this.blurTimer = setTimeout(() => {
        this.active = false
      }, 300)
    },
    highlight(index) {
      const length = this.suggestions.length
      if (index < 0) {
        index = length - 1
      }
      if (index >= length) {
        index = 0
      }
      const suggestion = this.$el.querySelector('.suggestions-list')
      if (suggestion) {
        const suggestionList = suggestion.querySelectorAll('.suggestions-list li')
        const highlightItem = suggestionList[index]
        const scrollTop = suggestion.scrollTop
        const offsetTop = highlightItem.offsetTop

        if (offsetTop + highlightItem.scrollHeight > (scrollTop + suggestion.clientHeight)) {
          suggestion.scrollTop += highlightItem.scrollHeight
        }
        if (offsetTop < scrollTop) {
          suggestion.scrollTop -= highlightItem.scrollHeight
        }
        this.highlightedIndex = index
        this.inputKeyword = `${this.suggestions[index]}`
      }
    },
    getData(value) {
      if (!value) {
        this.suggestions = []
        return
      }
      this.fetchSuggestions(value, (suggestions) => {
        if (value === this.inputKeyword) {
          if (Array.isArray(suggestions)) {
            this.suggestions = suggestions
            this.highlightedIndex = -1
          } else {
            console.error('autocomplete suggestions must be an array')
          }
        }
      })
    },
    clearInput() {
      this.inputKeyword = null
      this.close()
    },

    close() {
      this.suggestions = []
    },
    select(s) {
      this.$emit('select-suggestion', s)
      this.inputKeyword = s
      this.handleSearch()
    },
    handleEnterEvent() {
      if (!this.imeFlag) {
        this.handleSearch()
      }
    },
    handleSearch() {
      this.close()
      this.$emit('keyword-changed', this.inputKeyword)
    }

  }
}
</script>

<style lang="less" scoped>
.search-box {
  background: #ffffff;
  border-radius: 2px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  border: 1px solid @theme-border-color;
  &.search-box-active{
    border: 1px solid @theme-color;
  }
  .auto-complete{
    position: absolute;
    width: calc(100% - 24px);
    height: 100%;
    left: 0;
    top: 0;
    background: #fff;
    z-index: 99;
  }
  .search-button {
    font-size: 12px;
    font-weight: bold;
    border-width: 0;
    color: #8892A0;
    background: transparent;
    cursor: pointer;
    &:hover {
      color: @theme-hover-color;
    }
  }

  .search-input {
    height: 100%;
    box-sizing: border-box;
    padding-left: 4px;
    input {
      font-size: 12px;
      background: transparent;
      &::placeholder {
        color: @theme-border-color;
        position: relative;
        left: 0;
      }
    }
    .clear-input-btn {
      color: rgba(35, 40, 50, 0.4);
      font-size: 12px;
      cursor: pointer;
      padding-left: 8px;
      padding-right: 8px;
    }
    &.search-input-focused{
      background: #ffffff;
    }
  }
  .suggestions-list{
    position: absolute;
    top: calc(100% + 1px);
    left: 0;
    width: 100%;
    font-size: 12px;
    border: 1px solid @theme-border-color;
    border-radius: 2px;
    background: #fff;
    color: #50505A;
    .suggestion{
      height: 24px;
      line-height: 24px;
      padding: 0 4px;
      cursor: pointer;
      &.suggestion-selected,&:hover{
        background: #F5F5FA;
        color: @theme-color;
      }
    }
  }

}

</style>
